import { api } from "../api";

/**
 * ticketsfindAllByCustomerAndActivated - Function that finds on database all tickets by customer
 * /departments/{id}/tickets/{status}
 * method GET 
 * @async-function
 */
const ticketsfindAllByCustomerAndActivated = async (token: string, managerId: number, customerId: number,  id: number, status: string, page: number, size: number, ignoreDepartments: boolean = false) => {
    const response = await api.get(
        `departments/${managerId}/${id}/${customerId}/tickets/${status}?page=${page}&size=${size}&ignoreDepartments=${ignoreDepartments}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default ticketsfindAllByCustomerAndActivated;